import ModelTypeConstants from 'constants/ModelTypeConstants';
import {parseFolderItemIdFromURL} from 'folder-items/FileUtil';
import APIUtil from 'util/APIUtil';

function parseTokenAsApiId(token: string): string | null {
  const trimmed = token.trim();
  if (trimmed.length === 0) {
    return null;
  }
  return parseFolderItemIdFromURL(trimmed) ?? trimmed;
}

/**
 * Parses comma- or whitespace-separated API IDs.
 *
 * Returns a list of API IDs if every token matches one of the given model types. Passing more than
 * one type accepts a mixed paste, so long as every ID is one of them.
 *
 * @package
 */
export function parseApiIdsClipboardContent(
  text: string,
  modelTypes: ModelTypeConstants | ReadonlyArray<ModelTypeConstants>
): Array<string> | null {
  const allowedTypes = new Set(Array.isArray(modelTypes) ? modelTypes : [modelTypes]);
  const apiIds = text
    .split(/[,\s]+/)
    .map((token) => parseTokenAsApiId(token))
    .filter((apiId): apiId is string => apiId != null);
  if (apiIds.length === 0) {
    return null;
  }
  const maybeTypes = apiIds.map((apiId) => APIUtil.apiIdToMaybeType(apiId));
  if (!maybeTypes.every((maybeType) => maybeType != null && allowedTypes.has(maybeType))) {
    return null;
  }
  return apiIds;
}
